<template>
    <div>
        <select class="form-control" v-model="selected" @change="updateValue($event.target.value)">
            <option readonly value="null">Select Country</option>
            <option value="United Kingdom">United Kingdom</option>

            <!--
            <option value="England">England</option>
            <option value="Scotland">Scotland</option>
            <option value="Wales">Wales</option>
            <option value="Northen Ireland">Northen Ireland</option>
            <optgroup label="Popular">
                <option v-for="country in popular" :key="country.id" :value="country.iso_a_2">{{ country.name.en }}</option>
            </optgroup>
            <optgroup :label="region.region" v-for="region in regions" :key="region.id">
                <option v-for="country in region.countries" :value="country.iso_a_2">{{ country.name.en }}</option>
            </optgroup>
            -->
        </select>
    </div>
</template>

<script>
    import Country from '../../Services/Country.js';

    export default {
        props: ['value'],
        data() {
            return {
                selected: null,
                error: false,
                service: Country
            }
        },
        methods: {
            updateValue(value) {
                this.$emit('input', value);
            },
        },
        mounted() {
            this.$nextTick(() => {
                this.selected = this.value;
            });
        },
        computed: {
            regions() {
                return this.service.getRegions();
            },
            popular() {
                return this.service.getPopular();
            }
        }
    }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// resources/assets/js/Components/Elements/CountrySelect.vue